import api from '@pray/shared/utils/api';

/**
 * Generate an impact report for an artist.
 *
 * @param {Object} params
 * @param {string} params.artistId - The artist UUID
 * @param {Object} [params.breakevenData] - Optional breakeven projection data
 * @param {Object} [params.paybackData] - Optional payback analysis data
 * @param {string} [params.reportVariant] - Report variant: 'impact' | 'revenue-detail' | 'pptx'
 * @returns {Promise<Object>} The created impact report
 */
export async function generateImpactReport({ artistId, breakevenData, paybackData, reportVariant }) {
  const url = `/web/studio/artists/${artistId}/analytics/revenue/reports`;
  const body = {};
  if (breakevenData) body.breakeven_data = breakevenData;
  if (paybackData) body.payback_data = paybackData;
  if (reportVariant) body.report_variant = reportVariant;
  const response = await api.executePostRequest(url, Object.keys(body).length > 0 ? body : {});
  return response.data.data;
}
